import P from 'prop-types';
import { Api } from '../../services/api';
import { useEffect, useState } from 'react';
import { conversorData } from '../../utils/dataFunc';

// eslint-disable-next-line react/prop-types
export const CanhotoView = ({ id, close }) => {
  const [canhoto, setCanhoto] = useState(null);

  const findCanhoto = async () => {
    try {
      console.log('Canhoto:', id);
      const resp = await Api.get(`/canhoto/${id}`);

      setCanhoto(resp.data);
      console.log(resp.data);
    } catch (e) {
      console.log(e.message);
    }
  };

  const updateStatusCanhoto = async (id, status) => {
    try {
      await Api.put(`/canhoto/update/${id}`, {
        idStatus: '' + status,
      });

      await findCanhoto();
    } catch {
      alert('Não deu certo!');
    }
  };

  useEffect(() => {
    console.log('Hello');
    findCanhoto();
  }, []);

  return (
    <div className="">
      {canhoto && (
        <>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">
              Canhoto - NF {canhoto.nf}
            </h1>
            <button type="button" className="btn-close" aria-label="Close" onClick={() => close()}></button>
          </div>
          <div
            className="modal-body p-1"
            style={{ overflowX: 'hidden', height: '73vh', overflowY: 'auto', maxHeight: '73vh' }}
          >
            <div className="container p-3">
              <div className="row">
                <p>Data de envio: {conversorData(canhoto.updatedAt)}</p>
                <img
                  src={`https://canhoto.srembalagens.com.br/${canhoto.arquivo}?a`}
                  className="img-fluid mb-2"
                  style={{ width: '100%' }}
                />
                <a
                  type="button"
                  className="btn btn-secondary mt-1 mb-3"
                  href={`https://maps.google.com/?q=${canhoto.latitude},${canhoto.longitude}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Abrir localização no Google Maps
                </a>
              </div>
            </div>
          </div>
          <div className="modal-footer" style={{ borderTop: '1px solid #bdbdbd' }}>
            {canhoto.idStatus != 3 && (
              <>
                <button
                  type="button"
                  className="btn btn-danger mt-2"
                  style={{ marginRight: '8px' }}
                  onClick={() => updateStatusCanhoto(id, 1)}
                >
                  Recusar
                </button>
                <button type="button" className="btn btn-success mt-2" onClick={() => updateStatusCanhoto(id, 3)}>
                  Aprovar
                </button>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

CanhotoView.propTypes = {
  id: P.number,
};
